/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiSecurityScheme } from '../../asyncapi/models/AaiSecurityScheme';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { AbstractCommand } from '../AbstractCommand';
import { JsonCompat } from '../../compat/JsonCompat';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { DocumentType } from '../../core/models/DocumentType';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20SecurityScheme } from '../../openapi/v2/models/Oas20SecurityScheme';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30SecurityScheme } from '../../openapi/v3/models/Oas30SecurityScheme';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Oas20SecurityDefinitions } from '../../openapi/v2/models/Oas20SecurityDefinitions';
import { Oas30Components } from '../../openapi/v3/models/Oas30Components';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';
import { Node } from '../../core/models/Node';
import { Aai20Components } from '../../asyncapi/v2/models/Aai20Components';

/**
 * A command used to delete all security schemes from a document or operation.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllSecuritySchemesCommand extends AbstractCommand {
    public _oldSecuritySchemes : Array<any>;

    constructor() {
        super();
        if(this._oldSecuritySchemes===undefined) this._oldSecuritySchemes = null;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllSecuritySchemesCommand] Executing.");
        this._oldSecuritySchemes = <any>([]);
        if(document.getDocumentType() === DocumentType.openapi2) {
            let doc : Oas20Document = <Oas20Document>document;
            if(!this.isNullOrUndefined(doc.securityDefinitions)) {
                doc.securityDefinitions.getSecuritySchemes().forEach((scheme) => {
                    let savedScheme : any = Library.writeNode(scheme);
                    JsonCompat.setPropertyString(savedScheme, "__name", scheme.getSchemeName());
                    /* add */(this._oldSecuritySchemes.push(savedScheme)>0);
                });
            }
            doc.securityDefinitions = null;
        }
        if(document.getDocumentType() === DocumentType.openapi3) {
            let doc : Oas30Document = <Oas30Document>document;
            if(!this.isNullOrUndefined(doc.components)) {
                doc.components.getSecuritySchemes().forEach(((doc) => {
                    return (scheme) => {
                        let savedScheme : any = Library.writeNode(scheme);
                        JsonCompat.setPropertyString(savedScheme, "__name", scheme.getSchemeName());
                        /* add */(this._oldSecuritySchemes.push(savedScheme)>0);
                        doc.components.removeSecurityScheme(scheme.getSchemeName());
                    }
                })(doc));
            }
        }
        if(document.getDocumentType() === DocumentType.asyncapi2) {
            let doc : Aai20Document = <Aai20Document>document;
            if(!this.isNullOrUndefined(doc.components)) {
                doc.components.getSecuritySchemesList().forEach(((doc) => {
                    return (scheme) => {
                        let savedScheme : any = Library.writeNode(scheme);
                        JsonCompat.setPropertyString(savedScheme, "__name", scheme.getSchemeName());
                        /* add */(this._oldSecuritySchemes.push(savedScheme)>0);
                        doc.components.removeSecurityScheme(scheme.getSchemeName());
                    }
                })(doc));
            }
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllSecuritySchemesCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldSecuritySchemes) || /* size */(<number>this._oldSecuritySchemes.length) === 0) {
            return;
        }
        if(document.getDocumentType() === DocumentType.openapi2) {
            let doc : Oas20Document = <Oas20Document>document;
            if(this.isNullOrUndefined(doc.securityDefinitions)) {
                doc.securityDefinitions = doc.createSecurityDefinitions();
            }
            this._oldSecuritySchemes.forEach(((doc) => {
                return (savedScheme) => {
                    let name : string = JsonCompat.consumePropertyString(savedScheme, "__name");
                    let scheme : Oas20SecurityScheme = doc.securityDefinitions.createSecurityScheme(name);
                    Library.readNode(savedScheme, scheme);
                    doc.securityDefinitions.addSecurityScheme(name, scheme);
                }
            })(doc));
        }
        if(document.getDocumentType() === DocumentType.openapi3) {
            let doc : Oas30Document = <Oas30Document>document;
            if(this.isNullOrUndefined(doc.components)) {
                doc.components = doc.createComponents();
            }
            this._oldSecuritySchemes.forEach(((doc) => {
                return (savedScheme) => {
                    let name : string = JsonCompat.consumePropertyString(savedScheme, "__name");
                    let scheme : Oas30SecurityScheme = doc.components.createSecurityScheme(name);
                    Library.readNode(savedScheme, scheme);
                    doc.components.addSecurityScheme(name, scheme);
                }
            })(doc));
        }
        if(document.getDocumentType() === DocumentType.asyncapi2) {
            let doc : Aai20Document = <Aai20Document>document;
            if(this.isNullOrUndefined(doc.components)) {
                doc.components = doc.createComponents();
            }
            let nodeFactory : Aai20NodeFactory = new Aai20NodeFactory();
            this._oldSecuritySchemes.forEach(((doc,nodeFactory) => {
                return (savedScheme) => {
                    let name : string = JsonCompat.consumePropertyString(savedScheme, "__name");
                    let scheme : AaiSecurityScheme = nodeFactory.createSecurityScheme(doc.components, name);
                    Library.readNode(savedScheme, scheme);
                    doc.components.addSecurityScheme(name, scheme);
                }
            })(doc,nodeFactory));
        }
    }
}
DeleteAllSecuritySchemesCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllSecuritySchemesCommand";
DeleteAllSecuritySchemesCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




